import { extendVariants, Progress as HeroProgress, ProgressProps as HeroProgressProps } from '@heroui/react';
import { twMerge } from 'tailwind-merge';

import { HeroBaseProps } from '../utils';

// For all Progress props see https://v2.heroui.com/docs/components/progress
export const Progress = extendVariants(
  (
    props: HeroBaseProps<
      HeroProgressProps,
      | 'label'
      | 'size'
      | 'radius'
      | 'color'
      | 'value'
      | 'valueLabel'
      | 'minValue'
      | 'maxValue'
      | 'showValueLabel'
      | 'disableAnimation'
      | 'isDisabled'
    > & {
      size?: Extract<HeroProgressProps['size'], 'xs' | 'sm' | 'md'>;
      radius?: Extract<HeroProgressProps['radius'], 'sm' | 'full'>;
      color?: Extract<HeroProgressProps['color'], 'primary' | 'danger' | 'secondary' | 'foreground'>;
    },
  ) => (
    <HeroProgress
      {...props}
      classNames={{
        ...props.classNames,
        track: twMerge('bg-secondary-200', props.classNames?.track),
        label: twMerge('text-sm', props.classNames?.label),
        value: twMerge('text-sm', props.classNames?.value),
      }}
    />
  ),
  {
    variants: {
      color: {
        primary: {
          indicator: 'bg-primary-600',
        },
        secondary: {
          indicator: 'bg-secondary-500',
        },
        danger: {
          indicator: 'bg-danger-500',
        },
        foreground: {
          indicator: 'bg-secondary-950',
        },
      },
      size: {
        xs: {
          track: 'h-1',
        },
        sm: {
          track: 'h-1.5',
        },
        md: {
          track: 'h-2',
        },
      },
    },
    defaultVariants: {
      radius: 'full',
      size: 'md',
      color: 'primary',
    },
  },
);

export type ProgressProps = HeroProgressProps;
